import React, {  useEffect } from 'react'
import { Box, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import moment from 'moment';


const ProgramDirectoryVersion = (props) => {


  const [tableData] = React.useState(props.rowData.program_versions)
  const [loading] = React.useState(false)
  const [columns] = React.useState([
    { title: 'Version Name', field: 'version_name', },
    { title: 'Description', field: 'description', },
    { title: 'Program Uploaded Date', field: 'program_uploaded_date', editable: 'never',
      render: rowData => rowData.program_uploaded_date ? moment(rowData.program_uploaded_date).format('DD-MM-YYYY') : ''
    },
    {
      title: 'Date Created', field: 'date_created', editable: 'never',
      render: rowData => rowData.date_created ? moment(rowData.date_created).format('DD-MM-YYYY') : ''
    }

  ])


  // const getData = () => {
  //   Service.get(`/api/program/version`, {
  //     headers: {
  //       Authorization: "Token " + token,
  //     },
  //   })
  //     .then(res => {
  //       setTableData(res.data)
  //       setLoading(false)

  //     })
  //     .catch(error => {
  //       console.log(error)
  //       enqueueSnackbar('Something went wrong!', {
  //         variant: 'error'
  //       });
  //     });
  // }

  useEffect(() => {
    // getData()
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>{loading ? <Box display='flex' justifyContent='center' alignItems='center' width='100%'><CircularProgress /></Box> :
      <Box m={2}>
        <TableContainer component={Paper}>
          {/* <Box display='flex' justifyContent='space-between' alignItems='center' width='100%' paddingX={2}>
            <Typography variant="h5">{props.data?.name}</Typography>
            <Box>
              <Button onClick={() => setAddDialogOpen(true)} ><Tooltip title="Add"><AddBoxIcon /></Tooltip></Button>
            </Box>
          </Box> */}
          <Table>
            <TableHead>
              <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                {columns && columns.map((column) => (
                  <TableCell key={column.field}>{column.title}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData && tableData.map((row, idx) => (
                <React.Fragment key={row.key || idx}>
                  <TableRow key={row.id}>
                    {columns && columns.map((column) => (
                      <TableCell>{column.render ? column.render(row) : row[column.field]}</TableCell>
                    ))}
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>}
    </div>
  )
}

export default ProgramDirectoryVersion